import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { ReactComponent as Exit } from '../../img/common/exit.svg';
import { updateRooms } from '../../slice/chatGroupSlice';
import { leaveRoom, selectVoiceCall } from '../../slice/voiceCallSlice';

type ExitButtonProps = {
    height: number;
    width: number;
    color: string;
};

export const ExitButton: React.FC<ExitButtonProps> = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { group, room } = useSelector(selectVoiceCall);
    const leaveHandler = async () => {
        if (group !== undefined && room !== undefined) {
            await dispatch(leaveRoom({ groupId: group.id, roomId: room.id }));
            dispatch(updateRooms({ groupId: group.id, roomIds: [room.id] }));
            history.push(`/groups/${group.id}`);
        }
    };

    return (
        <Exit
            height={props.height}
            width={props.width}
            fill={props.color}
            role="img"
            aria-label="退出する"
            onClick={leaveHandler}
            style={{ cursor: 'pointer' }}
        />
    );
};
